import { Component, Input, OnInit } from '@angular/core';
import { CSSMonitorService } from '../../services/css-monitor.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'need-help-modal',
    templateUrl: 'need-help.component.html',
    standalone: false
})

export class NeedHelpComponent implements OnInit {
	private subscription: Subscription = null;
	public cssDisabled:boolean = false;
  
	@Input()
	id:string;

	constructor(
		private cssMonitorService: CSSMonitorService
	) { }

	screenShotInfoShown:boolean;

	ngOnInit(): void {
		this.screenShotInfoShown = false;
		this.cssMonitorService.start();
        this.subscription = this.cssMonitorService.styleChangeEvent.subscribe(
			(gotCss:string) => {
				if (gotCss === this.cssMonitorService.CSS_DISABLED) {
					this.handleCSSDisabled();
				} else {
					this.handleCSSEnabled();
				}
			}
		);
	}

	ngOnDestroy() {
        this.subscription.unsubscribe();
    }

	showScreenShotInfo(): void {
		this.screenShotInfoShown = true; 
	}

	showHelpInfo(): void {
		this.screenShotInfoShown = false;
	}

	reset():void {
		this.screenShotInfoShown = false;
	}

	protected handleCSSDisabled() {
		this.cssDisabled = true;
	}

	protected handleCSSEnabled() {
		this.cssDisabled = false;
	}

}
